import { Question } from './question.js';

export class MailingQuestion extends Question {
    constructor(question, ctx) {
        super(question, ctx);
        this.answer = [''];
        this.selectedOptIn = [];
    }

    renderContent() {
        let emailBlock = document.createElement('div');
        let text = document.createElement('input');
        text.classList.add('ph-input--email');
        text.type = 'email';
        text.style.marginTop = '16px';
        text.placeholder = this.question.placeHolder;
        text.setAttribute('aria-label', this.question.placeHolder || 'Email address');
        text.setAttribute('autocomplete', 'email');
        this.emailInput = text;

        text.rows = 1;

        text.addEventListener('focus', () => {
            setTimeout(() => text.scrollIntoView({ block: 'center' }), 300);
        });

        text.addEventListener('input', () => {
            this.answer[0] = text.value;
            if (this.validateEmail(text.value)) {
                this.ctx.updateAnswers(this.question, this.answer[0]);
            }
        });
        emailBlock.appendChild(text);

        if (this.question.showOptIn === true || this.question.showOptIn === '1') {
            let optInBlockElement = document.createElement('div');
            optInBlockElement.classList.add('ph-optin');
            emailBlock.appendChild(optInBlockElement);

            let answerOption = document.createElement('div');
            answerOption.style.display = 'flex';
            answerOption.style.alignItems = 'flex-start';
            answerOption.style.gap = '8px';
            answerOption.style.marginTop = '8px';

            let label = document.createElement('label');
            label.style.textAlign = 'left';
            label.htmlFor = 'purpose' + this.question.id;
            const noticeText = this.question.notice?.replace(
                /\[([^\]]+)\]\(([^)]+)\)/g,
                '<a href="$2" target="_blank" style="color: var(--ph-element-color); text-decoration: underline;">$1</a>'
            );

            label.innerHTML = noticeText;
            label.classList.add('ph-optin__label');

            let input = document.createElement('input');
            input.type = 'checkbox';
            input.id = 'purpose' + this.question.id;
            input.name = 'purpose';
            input.value = 'purpose';
            input.classList.add('ph-input--checkbox');

            answerOption.appendChild(input);
            answerOption.appendChild(label);

            input.addEventListener('click', () => {
                if (input.checked) {
                    this.selectedOptIn.push('purpose');
                } else {
                    const idx = this.selectedOptIn.indexOf('purpose');
                    if (idx > -1) {
                        this.selectedOptIn.splice(idx, 1);
                    }
                }
            });
            optInBlockElement.appendChild(answerOption);

            let answerOption1 = document.createElement('div');
            answerOption1.style.display = 'flex';
            answerOption1.style.alignItems = 'flex-start';
            answerOption1.style.gap = '8px';
            answerOption1.style.marginTop = '8px';

            let label1 = document.createElement('label');
            label1.htmlFor = 'condition' + this.question.id;
            label1.style.textAlign = 'left';
            const checkboxNoticeText = this.question.checkboxText?.replace(
                /\[([^\]]+)\]\(([^)]+)\)/g,
                '<a href="$2" target="_blank" style="color: var(--ph-element-color); text-decoration: underline;">$1</a>'
            );
            label1.innerHTML = checkboxNoticeText;

            label1.classList.add('ph-optin__label');

            let input1 = document.createElement('input');
            input1.type = 'checkbox';
            input1.id = 'condition' + this.question.id;
            input1.name = 'condition';
            input1.value = 'condition';
            input1.classList.add('ph-input--checkbox');

            answerOption1.appendChild(input1);
            answerOption1.appendChild(label1);

            if (this.question.showMoreCheckbox === '0' || this.question.showMoreCheckbox === false || this.question.showMoreCheckbox === 0) {
                answerOption1.style.display = 'none';
            }

            input1.addEventListener('click', () => {
                if (input1.checked) {
                    this.selectedOptIn.push('condition');
                } else {
                    const idx = this.selectedOptIn.indexOf('condition');
                    if (idx > -1) {
                        this.selectedOptIn.splice(idx, 1);
                    }
                }
            });
            optInBlockElement.appendChild(answerOption1);
        }

        return emailBlock;
    }

    renderNextButton() {
        let nextButton = document.createElement('button');
        nextButton.classList.add('ph-btn--primary');
        nextButton.textContent = this.question.buttonName;
        nextButton.addEventListener('click', () => {
            let result = this.validateEmail(this.answer[0]);
            if (!result) {
                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                errorElement.classList.add('ph-error');
                errorElement.textContent = this.question.errorText;
                this.setAriaInvalid(this.emailInput);
            } else if (
                (this.question.showOptIn === true || this.question.showOptIn === '1') && !this.selectedOptIn.includes('purpose')
            ) {
                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                errorElement.classList.add('ph-error');
                errorElement.setAttribute('lang', 'de');
                errorElement.textContent = this.question.errorText;
                this.setAriaInvalid(this.emailInput);
            } else if (
                (this.question.showOptIn === true || this.question.showOptIn === '1') &&
                (this.question.showMoreCheckbox === true || this.question.showMoreCheckbox === '1')
                && (this.question.checkboxObligated === true || this.question.checkboxObligated === '1')
                && !this.selectedOptIn.includes('condition') && this.question.checkboxText
            ) {
                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                errorElement.classList.add('ph-error');
                errorElement.setAttribute('lang', 'de');
                errorElement.textContent = this.question.errorText;
                this.setAriaInvalid(this.emailInput);
            } else {
                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                errorElement.classList.remove('ph-error');
                errorElement.textContent = '';
                errorElement.removeAttribute('lang');
                this.clearAriaInvalid(this.emailInput);

                this.ctx.goNext(this.question, this.answer[0]);
            }
        });
        return nextButton;
    }

    validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    skipButtonElement() {
        if (this.question.isObligated === false || this.question.isObligated === 0 || this.question.isObligated === '0') {
            let skipButton = document.createElement('button');
            skipButton.id = 'skipButton' + this.question.id;
            skipButton.classList.add('ph-btn--secondary');

            skipButton.textContent = this.question.skipButtonName ? this.question.skipButtonName : '\u00dcberspringen';
            if (!this.question.skipButtonName) {
                skipButton.setAttribute('lang', 'de');
            }
            skipButton.addEventListener('click', () => {
                this.ctx.goNext(this.question, this.answer[0]);
            });
            return skipButton;
        }
        return null;
    }
}
